module.exports = __webpack_public_path__ + "img/comment-middle.004348b0.svg";